export const groupTypes = {
  EVENTS: 'EVENTS',
  PROFILE: 'PROFILE',
  SEGMENTS: 'SEGMENTS',
  COHORTS: 'COHORTS',
  TIME: 'TIME',
};

export const fieldTypes = {
  NUMBER: 'NUMBER',
  STRING: 'STRING',
  TIME: 'TIME',
  DATE: 'DATE',
  COHORT: 'COHORT',
  SEGMENT: 'SEGMENT',
  LIST: 'LIST',
};

export const dateTypes = [fieldTypes.COHORT, fieldTypes.TIME];

export const groupByExcludeFields = [fieldTypes.SEGMENT];

export const splitByExcludeFields = [fieldTypes.SEGMENT, fieldTypes.TIME];

export const filterClauseExcludeFields = [fieldTypes.TIME];
